.specification-dimensions-multiselect__container {
  display: flex;
  flex-flow: column nowrap;
}

.specification-dimensions-multiselect__container__wrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  & .ant-select-selector {
    padding: 8px 32px 8px 8px !important;
  }

  & .ant-select-single {
    height: unset !important;
  }
}

.specification-dimensions-multiselect__container .specification-dimensions-multiselect__select {
  min-width: 200px;
  width: 100%;
}

.specification-dimensions-multiselect__container .specification-dimensions-multiselect__label {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;

  white-space: nowrap;
}

.specification-dimensions-multiselect__container .specification-dimensions-multiselect__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}

.specification-dimensions-multiselect__dropdown__container .specification-dimensions-multiselect__header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  font-weight: 600;
  color: var(--color-blue-6);

  padding: 8px;

  border-bottom: 1px solid var(--color-blue-6);
}

.specification-dimensions-multiselect__dropdown__container .specification-dimensions-multiselect__add-button__container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  padding: 8px;
}

.specification-dimensions-multiselect__dropdown__container .specification-dimensions-multiselect__custom-option {
  color: var(--color-blue-6);
}
